import React, {ReactElement} from 'react';
import {Props} from './Props';
import StyledBoolean from '../../../../../../components/StyledBoolean';
import {LineChart} from 'react-chartkick';
import {chartColors} from '../../../../../../styles';

class DialogBridge extends React.Component<Props> {
    componentDidMount(): void {
        this.loadBridgeGraphData();
    }

    loadBridgeGraphData = (): void => {
        const {properties, onOpenDialog} = this.props;
        onOpenDialog(properties.isrsCode);
    };

    render(): ReactElement {
        const {bridgeHistoryData, properties, showRecordIds} = this.props;

        return (
            <React.Fragment>
                <table>
                    <tbody>
                        {showRecordIds && (
                            <tr>
                                <th>ID</th>
                                <td>{properties.id}</td>
                            </tr>
                        )}
                        <tr>
                            <th>Naam</th>
                            <td>{properties.name}</td>
                        </tr>
                        <tr>
                            <th>ISRS code</th>
                            <td>{properties.isrsCode}</td>
                        </tr>
                        <tr>
                            <th>Open</th>
                            <td>
                                <StyledBoolean value={properties.open} />
                            </td>
                        </tr>
                    </tbody>
                </table>

                <br />

                {bridgeHistoryData && (
                    <LineChart
                        colors={[chartColors[0]]}
                        data={bridgeHistoryData}
                        download={`Brugopening geschiedenis ${this.getBridgeName()}.png`}
                    />
                )}
            </React.Fragment>
        );
    }

    private getBridgeName = (): string => {
        const {properties} = this.props;

        if (properties.name && properties.name.length) {
            return properties.name;
        }
        if (properties.isrsCode && properties.isrsCode.length) {
            return properties.isrsCode;
        }

        return properties.id;
    };
}

export default DialogBridge;
